import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation CreateChannelsGroup($model: ChannelGroupInput!) {
  createGroupChannel(group: $model) {
    id
    name
    description
    config
  }
}`;

function createChannelsGroup(config, model) {
  return apollo.client.mutate({
    mutation,
    variables: {
      model: {
        ...model,
        config: JSON.stringify(config),
      },
    },
  }).then((res) => res.data.createGroupChannel);
}

export default createChannelsGroup;
